// Heru Days: 50% OFF en declaraciones pendientes (regularizaciones). El
// descuento se aplica server-side al finalizar la compra (mismo criterio que la
// promo del triunfo: el front no hace matemática de promo, el `final` del
// catálogo ya trae el precio real). Corre hasta fin de mes; al vencer, el
// GlobalBannerStack regresa solo al banner de primer mes gratis. Hora de México
// (-06:00): el switch ocurre a las 00:00 del 1 de agosto.

// Partes del mensaje de la marquesina (mismo diseño que el banner del sitio
// heru.app): tramos de texto separados por ◆, con un CTA al final.
export type HeruDaysBannerPart =
	| { type: 'strong'; text: string }
	| { type: 'text'; text: string }
	| { type: 'cta'; text: string }
	| { type: 'sep' };

export const HERU_DAYS_REG_MESSAGE: HeruDaysBannerPart[] = [
	{ type: 'strong', text: '🔥 ¡Arrancó el Heru Days!' },
	{ type: 'sep' },
	{
		type: 'strong',
		text: 'Pon al día tus declaraciones pendientes del SAT con 50% de dto.',
	},
	{ type: 'sep' },
	{
		type: 'text',
		text: 'Presentamos tus periodos atrasados por ti para que mantengas tu historial en orden',
	},
	{ type: 'sep' },
	{
		type: 'text',
		text: 'El descuento se aplica automáticamente al finalizar tu compra',
	},
	{ type: 'sep' },
	{ type: 'strong', text: '⏳ Oferta disponible hasta fin de mes' },
	{ type: 'sep' },
	{ type: 'cta', text: 'Regularízate ahora →' },
];

export const HERU_DAYS_REG_PROMO = {
	ariaLabel:
		'¡Arrancó el Heru Days! Pon al día tus declaraciones pendientes del SAT con 50% de descuento. Presentamos tus periodos atrasados por ti. Oferta disponible hasta fin de mes.',
	startsAt: new Date('2026-07-24T00:00:00-06:00'),
	endsAt: new Date('2026-08-01T00:00:00-06:00'),
} as const;

export const isHeruDaysRegPromoActive = (now: Date = new Date()): boolean =>
	now >= HERU_DAYS_REG_PROMO.startsAt && now < HERU_DAYS_REG_PROMO.endsAt;
